import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../../core/services/data.service';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss']
})
export class TermsOfServiceComponent implements OnInit {

  tOSTxt!: any;

  constructor(private dataService: DataService) {
  }

  ngOnInit(): void {
    this.dataService.legals$.subscribe(legals => {
      this.tOSTxt = legals;
    });
  }
}
